export { dictionaryIds } from '@shared';

export const moduleName = 'dict';

export const summitId = 22;
